import { Datepicker } from 'vanillajs-datepicker';
import pt from 'vanillajs-datepicker/locales/pt';

export function init() {
    Object.assign(Datepicker.locales, pt);

    document.querySelectorAll(".input-date-group").forEach((groupInput) => {
        const inputElement = groupInput.querySelector("input")
        new Datepicker(inputElement, { language: "pt" });

        inputElement.addEventListener("click", () => {
            inputElement.parentNode.classList.add("open")
        })

        inputElement.addEventListener("blur", () => {
            inputElement.parentNode.classList.remove("open")
        })
    })
}
